import { MaterielAdduction } from "./materiel-adduction";
import { PrelevementAir } from "./prelevement-air";

export class MesureAdduction {
    Code!: string;
    Date!: Date;
    Localisation!: string;
    SamplingId!: number;
    SampleCode!: string;
    Observation!: string;
    AppareilMesure!: string;
    MaterielAdduction: MaterielAdduction[] = [];
    PrelevementAir: PrelevementAir[] = [];
}